import PropTypes from "prop-types";
import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { connect } from "react-redux";
import Apilogin from "../api/ApiLogin";
import config from "../config/app.config";
import {
  authenticate,
  getLoginTime,
  getToken,
  getUserInfo,
  removeLocalStorage,
} from "../config/authsave";
import { startTokenCheckInterval } from "../helpers/auth";

import {
  AndroidOutlined,
  AppleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  GoogleOutlined,
  KeyOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Divider,
  FloatButton,
  Input,
  message,
  Modal,
  notification,
  QRCode,
  Result,
  Spin,
  Tabs,
  Tooltip,
} from "antd";
import Swal from "sweetalert2";
import LogoWhite from "../assets/images/logo/payeasy1.png";

import ChangePasswordComponent from "./change_password/change_password";
import FormVerify from "./form-verify";
// import Learn from "./learn";

import { onLoggedin } from "../actions";
import { startInactivityManager } from "../AppBehaviorManager";
import AppContext from "../components/AppContext";
import {
  generateUserDeviceID,
  sendApiTelegram_call_api_error,
  showToast,
  // sendApiTelegram_login,
} from "../utils";
import i18next, { t } from "i18next";
import Learn from "./learn";
import SelectLanguage from "../components/Dropdown/SelectLanguage";
import { withTranslation } from "react-i18next";
import { setCookie } from "../utils/cookieHelper";

const alertShownKey = "tokenExpiredAlertShow";

class Login extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    console.warn = () => { };
    this.state = {
      isLoad: true,
      passwordVisible: false,
      ip: { data: "" },
      msg: "",
      showMainChangePasswordFlow: false,
      password_change_prop: "",
      username_change_prop: "",
      paramsIP_change_prop: "",
      params_user_device_id_change_prop: "",

      modalKey: "1",
      isModalOpen: false,
      isModalLoading: true,

      percentSpin: 0,
      formApiError: "",
      dataURL_verify: undefined,
      txtAlert_verify: undefined,
      userName_verify: "",
      isVerifyingOtp: false,
      isLoginButtonDisabled: false,
      isSpinning: false,
      isLoginFormVisible: true,
      formData: {
        username: "",
        password: "",
      },
    };

    // Bind methods
    this.getIP = this.getIP.bind(this);
    this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
    this.checkPlatform = this.checkPlatform.bind(this);
    this.showHelpModal = this.showHelpModal.bind(this);
    this.handleFormInputChange = this.handleFormInputChange.bind(this);
    this.handleTabsChange = this.handleTabsChange.bind(this);
    this.downloadGoogleAuthenticator =
      this.downloadGoogleAuthenticator.bind(this);
    this.handleCopyText = this.handleCopyText.bind(this);
    this.processInitialPasswordChange =
      this.processInitialPasswordChange.bind(this);
    this.showLoaderWithPercentage = this.showLoaderWithPercentage.bind(this);
  }

  componentDidMount() {
    let token = getToken();
    let loginTime = getLoginTime();
    const { pageName } = this.context;
    let userInfo = getUserInfo();
    let selectedID = localStorage.getItem("selectedID");

    if (token || loginTime || userInfo || selectedID) {
      removeLocalStorage();
    }
    setTimeout(() => {
      this.setState({ isLoad: false }, () => pageName("login"));
    }, 1500);

    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");
    document.body.classList.add("theme-blue");

    this.getIP();

    const { old_password, old_username } = this.props;
    if (old_username && old_password) {
      this.setState({ isLoginFormVisible: false });
      this.processInitialPasswordChange(old_username, old_password);
    }

    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          username: userData.username,
          password: userData.password,
        },
      }));
    }
  }

  getIP() {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((result) => {
        this.setState({ ip: { data: result.ip } });
      })
      .catch((error) => console.error("Error fetching IP:", error));
  }

  checkPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("win") !== -1) return "Windows";
    if (userAgent.indexOf("mac") !== -1) return "macOS";
    if (userAgent.indexOf("linux") !== -1) return "Linux";
    if (userAgent.indexOf("android") !== -1) return "Android";
    if (userAgent.indexOf("iphone") !== -1 || userAgent.indexOf("ipad") !== -1)
      return "iOS";
    return "Unknown";
  }

  showLoaderWithPercentage = () => {
    let ptg = -10;
    // this.setState({ isSpinning: true }); // isSpinning should be controlled by the caller
    const interval = setInterval(() => {
      ptg += 5;
      this.setState({ percentSpin: ptg });
      if (ptg > 120) {
        clearInterval(interval);
        this.setState({ percentSpin: 0 });
      }
    }, 100);
  };

  processInitialPasswordChange(old_username, old_password_prop) {
    const { ip } = this.state;
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    let user_device_id = generateUserDeviceID();
    let apiParams = {
      password: old_password_prop,
      username: old_username,
      user_device_id: user_device_id,
      IP: ip?.data,
      platform: this.checkPlatform(),
    };

    this.setState({ isSpinning: true });
    Apilogin.first_time_login(apiParams)
      .then((res) => {
        this.setState({ isSpinning: false });
        if (res.data.success) {
          if (res.data.redirect === "changepassword") {
            Toast.fire({ icon: "success", title: res.data.message });
            this.setState({
              password_change_prop: res?.data?.user?.password,
              username_change_prop: res?.data?.user?.username,
              paramsIP_change_prop: res?.data?.user?.IP,
              params_user_device_id_change_prop:
                res?.data?.user?.user_device_id,
              showMainChangePasswordFlow: true,
            });
          }
        } else {
          Toast.fire({ icon: "error", title: res.data.message });
          this.setState({
            showMainChangePasswordFlow: false, // To show Result component
            msg: res.data.message,
          });
        }
      })
      .catch((err) => {
        this.setState({ isSpinning: false });
        Toast.fire({ icon: "error", title: err.message });
        console.log(err);
        this.setState({ msg: err.message, showMainChangePasswordFlow: false });
      });
  }

  openAntNotification = (type, messageContent) => {
    notification[type]({
      message: "Notification",
      description: messageContent,
    });
  };

  showAntMessage = (type, content) => {
    message[type](content);
  };

  handleFormInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
      formApiError: "", // Clear previous API error on input change
    }));
  };

  handleLoginSubmit = (e) => {
    e.preventDefault();
    let now = new Date().getTime();
    this.showLoaderWithPercentage();
    this.setState({ isLoginButtonDisabled: true, isSpinning: true });

    let user_device_id = generateUserDeviceID();
    const { username, password } = this.state.formData;
    const { ip } = this.state;
    const { history } = this.props;
    const { pageName, handleLogin } = this.context;

    const loginPayload = {
      username: username,
      password: password,
      user_device_id: user_device_id,
      IP: ip?.data || "000.0.000",
      platform: this.checkPlatform(),
    };

    if (!loginPayload?.username || !loginPayload?.password) {
      Swal.fire(
        "The information is incorrect.",
        "Please fill in all the required information.",
        "error",
      );
      this.setState({ isLoginButtonDisabled: false, isSpinning: false });
      return;
    }

    Apilogin.Postlogin(loginPayload)
      .then((res) => {
        this.setState({ txtAlert_verify: `${t(res.data.message)}` });
        if (res.data.redirect === "verify") {
          this.openAntNotification("success", `${t(res.data.message)}`);
          setTimeout(() => this.setState({ isSpinning: false }), 2100);
          this.setState({
            isVerifyingOtp: true,
            isLoginFormVisible: false,
            isLoginButtonDisabled: false,
            dataURL_verify: res.data.dataURL,
            userName_verify: res.data, // Contains user info for verify form
          });
          return;
        }

        if (res.data.success) {
          this.context.setLoadingInvoices(true);
          // sendApiTelegram_login(res, "login");

          showToast("success", `${t(res.data.message)}`);

          const tokenPayload = {
            token: res.data.token,
            userInfo: {
              id: res.data.user.id,
              username: res.data.user.username,
              name: res.data.user.name,
              role: res.data.user.role,
              roleID: res.data.user.roleID,
              Active_merchantId: res.data.user.Active_merchantId,
              created_at: res.data.user.created_at,
              admin_type: res.data.user.admin_type,
              admin_status: res.data.user.admin_status,
              merchantIds: res.data.user.merchantIds,
              updated_at: res.data.user.updated_at,
              user_device_id: res.data.user.user_device_id,
              // ไม่ต้องเก็บ password หรือข้อมูลเชิงลึกอื่นๆ
            }
          };
          const payload = {
            userToken: res?.data?.token,
            userData: tokenPayload?.userInfo,
            selectedID: tokenPayload?.userInfo?.Active_merchantId,
          };
          localStorage.setItem("selectedID", tokenPayload?.userInfo?.Active_merchantId,);

          const sessionData = {
            token: res?.data?.token,
            loginTime: now,
          };
          authenticate(tokenPayload);
          if (typeof handleLogin === "function") {
            handleLogin(payload);
          }
          if (this.props.onLoggedin) {
            this.props.onLoggedin(tokenPayload.userInfo, tokenPayload.token);
          }

          let user = tokenPayload?.userInfo?.username === "finance-88";
          sessionStorage.setItem(alertShownKey, "false");
          startTokenCheckInterval();
          startInactivityManager();
          // --- ส่วนที่เพิ่ม: เก็บ Token และ UserID ลงใน Cookie ---
          // สมมติว่าให้คุกกี้มีอายุ 24 ชั่วโมง
          if (res?.data?.token) {
            // --- [ส่วนที่เพิ่ม/แก้ไข: การเก็บลง Cookies] ---
            setCookie("userPayload", tokenPayload, 1);
            setCookie("sessionInfo", sessionData, 1);
            setCookie("token", res?.data?.token, 1);
          }
          // ------------------------------------------

          if (user) {
            setTimeout(() => {
              history.push("/invoices");
              this.setState({
                isLoginButtonDisabled: false,
                isSpinning: false,
              });
            }, 1500);
          } else {
            setTimeout(() => {
              history.push("/dashboard");
              pageName("dashboard");
              this.setState({
                isLoginButtonDisabled: false,
                isSpinning: false,
              });
            }, 1500);
          }
        } else {
          this.setState({ isLoginButtonDisabled: false, isSpinning: false });
          this.openAntNotification("error", t(res.data.message));
        }
      })
      .catch((err) => {
        sendApiTelegram_call_api_error(err, "login");
        setTimeout(
          () =>
            this.setState({ isSpinning: false, isLoginButtonDisabled: false }),
          2100,
        );
        this.openAntNotification("error", err.message);
        console.log(err);
      });
  };

  handleRememberMeChange = (event) => {
    const { username, password } = this.state.formData;
    if (event.target.checked) {
      localStorage.setItem("userData", JSON.stringify({ username, password }));
    } else {
      localStorage.removeItem("userData");
    }
  };

  showHelpModal = (e) => {
    this.setState({ isModalOpen: true, isModalLoading: true });
    setTimeout(() => this.setState({ isModalLoading: false }), 2000);

    let targetId = e?.currentTarget?.id; // Use currentTarget for direct event listener
    this.setState({ modalKey: targetId === "learn" ? "3" : "1" });
  };

  handleTabsChange = (key) => {
    this.setState({ modalKey: key });
  };

  downloadGoogleAuthenticator = () => {
    const userAgent = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod/.test(userAgent);

    if (isMobile) {
      const isAndroid = /Android/.test(userAgent);
      const isIOS = /iPhone|iPad|iPod/.test(userAgent);
      if (isAndroid) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";
      } else if (isIOS) {
        window.location.href =
          "https://apps.apple.com/us/app/google-authenticator/id388497605";
      } else {
        Swal.fire(
          "Platform Error",
          "No supported platform was found for this mobile device.",
          "warning",
        );
      }
    } else {
      // PC or other
      Swal.fire(
        "Platform Error",
        "Google Authenticator does not have a direct PC version. Please use it on your mobile device.",
        "warning",
      );
    }
  };

  handleCopyText = (text) => {
    navigator?.clipboard
      ?.writeText(text)
      .then(() => this.showAntMessage("success", "คัดลอกแล้ว: " + text))
      .catch(() => this.showAntMessage("error", "การคัดลอกล้มเหลว"));
  };
  setPasswordVisible = () => {
    let { passwordVisible } = this.state;
    let target = passwordVisible;
    this.setState({ passwordVisible: !target });
  };

  render() {
    const {
      isLoad,
      msg,
      showMainChangePasswordFlow,
      password_change_prop,
      username_change_prop,
      paramsIP_change_prop,
      params_user_device_id_change_prop,
      isSpinning,
      percentSpin,
      isLoginButtonDisabled,
      isLoginFormVisible,
      isVerifyingOtp,
      dataURL_verify,
      userName_verify,
      txtAlert_verify,
      isModalOpen,
      isModalLoading,
      modalKey,
      ip,
      passwordVisible,
    } = this.state;
    const { username, password } = this.state.formData;
    const { history } = this.props;
    const { handleLogin } = this.context;

    // Props for ChangePasswordComponent
    const changePasswordProps = {
      password: password_change_prop,
      username: username_change_prop,
      msg: msg,
      IP: paramsIP_change_prop,
      user_device_id: params_user_device_id_change_prop,
    };

    // Props for FormVerify component
    const formVerifyProps = {
      showLoading: this.showHelpModal,
      setSpinning: (val) => this.setState({ isSpinning: val }),
      showLoader: this.showLoaderWithPercentage,
      userName: userName_verify,
      ip: ip?.data,
      dataURL: dataURL_verify,
      txtAlert: txtAlert_verify,
      openNotification: this.openAntNotification,
      form_verify: isVerifyingOtp, // Prop name from functional component
      setForm_verify: (val) => this.setState({ isVerifyingOtp: val }),
      setForm_login: (val) => this.setState({ isLoginFormVisible: val }),
      setLoadingInvoices: this.context.setLoadingInvoices,
      history: history,
      handleLogin: handleLogin,
    };

    const tabItems = [
      {
        key: "1",
        label: t('tabs.download_ios'),
        icon: (
          <AppleOutlined style={{ display: "inline-flex", fontSize: "16px" }} />
        ),
        children: (
          <div className="text-center w-100">
            <div className="download">
              <Divider orientation="center">
                {t('download.title_ios')}
              </Divider>
              <QRCode
                style={{ margin: "0 auto" }}
                value="https://apps.apple.com/us/app/google-authenticator/id388497605"
              />
              <Tooltip title={t('download.tooltip_ios')}>
                <Input
                  placeholder="-"
                  className="mt-3"
                  style={{ cursor: "pointer", textTransform: "lowercase" }}
                  onClick={() =>
                    window.open(
                      "https://apps.apple.com/us/app/google-authenticator/id388497605",
                    )
                  }
                  value="https://apps.apple.com/us/app/google-authenticator/id388497605"
                  readOnly
                />
              </Tooltip>
            </div>
          </div>
        ),
      },
      {
        key: "2",
        label: t('tabs.download_android'),
        icon: (
          <AndroidOutlined
            style={{ display: "inline-flex", fontSize: "16px" }}
          />
        ),
        children: (
          <div className="text-center w-100" >
            <div className="download">
              <Divider orientation="center">
                {t('download.title_android')}
              </Divider>
              <QRCode
                style={{ margin: "0 auto" }}
                value="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
              />
              <Tooltip title={t('download.tooltip_android')}>
                <Input
                  placeholder="-"
                  className="mt-3"
                  style={{ cursor: "pointer", textTransform: "lowercase" }}
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
                    )
                  }
                  value="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                  readOnly
                />
              </Tooltip>
            </div>
          </div>
        ),
      },
      {
        key: "3",
        label: t('tabs.login_steps'),
        icon: (
          <GoogleOutlined
            style={{ display: "inline-flex", fontSize: "16px" }}
          />
        ),
        children: (
          <div className="w-100 container">
            {/* ส่งฟังก์ชัน t เข้าไปใน Learn เพื่อให้ภายในรองรับหลายภาษาด้วย */}
            <Learn t={t} />
          </div>
        ),
      },
    ];

    if (
      this.props.old_username &&
      this.props.old_password &&
      !isLoginFormVisible
    ) {
      if (isSpinning && !showMainChangePasswordFlow && !msg) {
        return <Spin spinning={true} fullscreen tip="checking..." />;
      }
      if (showMainChangePasswordFlow) {
        return <ChangePasswordComponent {...changePasswordProps} />;
      } else if (msg) {
        // Error occurred
        return <Result status="403" title="พบข้อผิดพลาด" subTitle={msg} />;
      }
      return <Spin spinning={true} fullscreen tip="กำลังเตรียมการ..." />;
    }

    return (
      <>
        <div className="">
          <div className="bg-body-tertiary d-flex flex-row align-items-center">
            {!isModalOpen && (
              <Tooltip title="How to log in with 2FA" className="">
                <FloatButton
                  id="learn"
                  onClick={this.showHelpModal}
                  icon={
                    <QuestionCircleOutlined
                      style={{ display: "inline-flex" }}
                    />
                  }
                  type="primary"
                />
              </Tooltip>
            )}
            <Modal
              title={
                <Divider orientation="left">
                  Google Authenticator Download
                </Divider>
              }

              maskClosable={false}
              width={750}
              footer={
                <Divider className="mb-2 mt-3" orientation="center">
                  {" "}
                  <p
                    className="versions text-center mb-0"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      color: "#888",
                      fontSize: "12px",
                    }}
                  >
                    Version: {config?.version}
                  </p>
                </Divider>
              }
              open={isModalOpen}
              confirmLoading={isModalLoading}
              onCancel={() => this.setState({ isModalOpen: false })}
            >

              <Card className="container" extra={<SelectLanguage i18n={i18next} t={t} />} style={{ width: "100%", background: "none", border: "none", boxShadow: "none" }}>
                <Tabs
                  activeKey={modalKey}
                  items={tabItems}
                  onChange={this.handleTabsChange}
                />
              </Card>
            </Modal>

            <Spin spinning={isSpinning} percent={percentSpin} fullscreen />
            <div className="">
              <div
                className="page-loader-wrapper"
                style={{ display: isLoad ? "block" : "none" }}
              >
                <div className="loader">
                  <div className="m-t-30">
                    <LoadingOutlined
                      style={{ fontSize: "48px", color: "#fff" }}
                    />
                  </div>
                  <p>Please wait...</p>
                </div>
              </div>
              <div className="hide-border">
                <div className="vertical-align-wrap">
                  <div className="vertical-align-middle auth-main">
                    <div className={`auth-box ${isLoad ? '' : 'in'}`}>
                      {isVerifyingOtp && <FormVerify {...formVerifyProps} />}
                      {isLoginFormVisible && (
                        <>
                          <Form
                            className={`${isLoginFormVisible && "in"}`}
                            onSubmit={this.handleLoginSubmit}
                          >
                            <div className="card">
                              <div className="header">
                                <img
                                  src={LogoWhite}
                                  width={150}
                                  alt=""
                                  style={{ margin: "10px" }}
                                />
                                <p className="lead">
                                  {t("Login to your account")}
                                </p>
                                <p className="h5 text-center mb-2"></p>

                                <p className="text-muted op-7 fw-normal text-center">
                                  {t("Welcome back admin")}{" "}
                                  {process.env.REACT_APP_ENV === "staging"
                                    ? "(STG)!"
                                    : null}
                                </p>
                              </div>
                              <div className="body">
                                <div
                                  className="form-auth-small"
                                  action="index.html"
                                >
                                  <InputGroup className="mb-3">
                                    <InputGroup.Text>
                                      <UserOutlined />
                                    </InputGroup.Text>
                                    <Form.Control
                                      placeholder="Username"
                                      style={{ border: "1px #eeeeee9e solid" }}
                                      name="username"
                                      type="text"
                                      autoFocus={false}
                                      autoComplete="false"
                                      value={username}
                                      onChange={this.handleFormInputChange}
                                    />
                                  </InputGroup>
                                  <InputGroup className="mb-4">
                                    <InputGroup.Text>
                                      <KeyOutlined />
                                    </InputGroup.Text>
                                    <Form.Control
                                      type={
                                        !passwordVisible ? "password" : "text"
                                      }
                                      style={{ border: "1px #eeeeee9e solid" }}
                                      placeholder="Password"
                                      autoComplete="false"
                                      name="password"
                                      autoFocus={false}
                                      value={password}
                                      onChange={this.handleFormInputChange}
                                    />
                                    <InputGroup.Text
                                      className="_end"
                                      onClick={() => this.setPasswordVisible()}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {!passwordVisible ? (
                                        <EyeOutlined />
                                      ) : (
                                        <EyeInvisibleOutlined />
                                      )}
                                    </InputGroup.Text>
                                  </InputGroup>

                                  <Button
                                    variant="primary"
                                    style={{ color: "#fff" }}
                                    disabled={isLoginButtonDisabled}
                                    type="primary"
                                    htmlType="submit"
                                    className="btn btn-primary btn-lg btn-block p-0"
                                  >
                                    {!isLoginButtonDisabled ? (
                                      <>{t("login")}</>
                                    ) : (
                                      <>
                                        <LoadingOutlined /> Loading...
                                      </>
                                    )}
                                  </Button>
                                  <div className="bottom">
                                    <p
                                      className="versions text-center mb-0"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        color: "#888",
                                        fontSize: "12px",
                                      }}
                                    >
                                      Version: {config?.version}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Form>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

Login.propTypes = {
  old_password: PropTypes.string,
  old_username: PropTypes.string,
  onLoggedin: PropTypes.func,
};

Login.defaultProps = {
  old_password: null,
  old_username: null,
  onLoggedin: () => { },
};

const mapStateToProps = (state) => ({
  // isLoggedIn: state.loginReducer.isLoggedin, // Example
});

const mapDispatchToProps = {
  onLoggedin,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));

